// Small change for git push test
import React, { useState, useRef } from "react";
import { container } from "./../../constants/styles";
import logoImg from "./../../assets/images/logo.png";
import welcomeImg from "./../../assets/images/welcome.png";
import readyImg from "./../../assets/images/ready.png";
import buttonImg from "./../../assets/images/button.png";
import stopImg from "./../../assets/images/stop_wasting.png";
import beforeImg from "./../../assets/images/before.png";
import includedImg from "./../../assets/images/included.png";
import freeGiftImg from "./../../assets/images/free_gift.png";
import analyzetImg from "./../../assets/images/analyzed.png";
import toolsImg from "./../../assets/images/tools.png";
import seeImg from "./../../assets/images/see.png";
import resultImg from "./../../assets/images/result.png";
import mediaImg from "./../../assets/images/media.png";
import bloggersImg from "./../../assets/images/bloggers.png";
import visaImg from "./../../assets/images/visa.png";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Form from "../../components/Form/Form";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";
import Popup from "../../components/Popup/Popup";
import { useScrollToRef } from "../../hooks/useScrollToRef";
import {
  REDIRECT_LINK,
  STRIPE_PRICE_ID,
  STRIPE_PUBLIC_KEY,
} from "../../constants/formConstants";
import discountImg from "./../../assets/images/common/discount.svg";
import { useTimer } from "../../hooks/useTimer";
import { useClientReferenceCookie } from "../../hooks/useClientReferenceCookie";

function Paywall() {
  const discountBlockRef = useRef(null);
  const formattedTime = useTimer(10);

  useClientReferenceCookie();
  const scrollToRef = useScrollToRef();

  const landingPlans = [
    {
      value: "0.99",
      text: "$1",
      trialValue: 0.99,
      trialValueText: "$0.99",
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
    {
      value: "9.78",
      text: "$9.78",
      trialValue: 9.78,
      trialValueText: "$9.78",
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
  ];

  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(STRIPE_PUBLIC_KEY)
  );

  const [plan, setPlan] = useState(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showPromoCode, setShowPromoCode] = useState(true);

  const isApplePayAvailible = useSelector(
    (state) => state.payment.isApplePayAvailible
  );

  const onGetClick = () => {
    if (discountBlockRef.current) {
      scrollToRef(discountBlockRef, 100);
      return;
    }
  };

  const onPlanClick = (plan) => {
    setPlan(plan.value);
  };

  const onClosePopupClick = () => {
    setPopupOpen(false);
  };

  const onPopupOpenClick = () => {
    setPopupOpen(true);
  };

  const onSuccess = () => {
    window.location.href = REDIRECT_LINK;
  };

  const renderFullForm = (onlyApplePay) => {
    return (
      <div className={`max-w-[450px] mx-auto`}>
        <Elements stripe={stripePromise}>
          <Form
            priceID={STRIPE_PRICE_ID}
            trialCost={plan}
            littleText={"little text"}
            title={""}
            onlyApplePay={onlyApplePay}
            successAction={onSuccess}
          />
        </Elements>
      </div>
    );
  };

  const renderPopupForm = () => {
    return (
      <div>
        <h3 className="text-[24px] font-[700] text-[rgb(0,46,56)] mb-2">
          Payment method
        </h3>
        <p className="text-[12px] text-[rgb(50,87,97)]">
          {" "}
          You will only be charged ${plan} for your 7-days trial
        </p>
        {renderFullForm()}
      </div>
    );
  };

  const TimerRender = () => {
    return (
      <div className="border-1 flex items-center justify-between border border-[#C2E8F3] bg-[#B7DEE9] p-4">
        <div>
          <p className="mb-0 text-[14px] font-[500] leading-[14px] text-[#0A364A]">
            Your color analysis results.
          </p>
          <p className="mb-[2px] text-[14px] font-[500] leading-[14px] text-[#0A364A]">
            expires in:
          </p>
          <p className="py-[5px] text-[28px] font-[900] leading-[28px] text-[#218BAF]">
            {formattedTime}
          </p>
        </div>

        <div>
          <Button
            buttonStyles={`!bg-[#00C65B] !font-[800] !text-[18px] !text-[#ffffff] !py-2 !px-[22px] !max-h-10`}
            text="Continue"
            blick={false}
            action={() => scrollToRef(discountBlockRef, 100)}
          />
        </div>
      </div>
    );
  };

  const getSeasonalPromoCode = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    let season = "";

    if (month >= 3 && month <= 5) {
      season = "SPRING";
    } else if (month >= 6 && month <= 8) {
      season = "SUMMER";
    } else if (month >= 9 && month <= 11) {
      season = "FALL";
    } else {
      season = "WINTER";
    }

    return `${season}${year}`;
  };

  const discountBlockRender = () => {
    return (
      <div>
        <div className="mb-1 flex items-center justify-between">
          <p className="text-[18px] font-[800] text-[#0A364A]">
            Promo code applied
          </p>
          <div
            onClick={() => scrollToRef(discountBlockRef, 100)}
            className="flex cursor-pointer items-center rounded-[8px] bg-[#08A0C8] px-3 py-[10px] text-[18px] font-[800] text-[#ffffff]"
          >
            <img src={discountImg} className="mr-1 min-w-5" alt="discount" />
            <p>{getSeasonalPromoCode()}</p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-[16px] font-[500] text-[#0A364A]">
            Promo code reserved for:
          </p>
          <p className="text-[16px] font-[500] text-[#0A364A]">
            {formattedTime}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className={`${container} py-10 pt-28`}>
      <div className="fixed left-0 top-0 z-[3] mb-6 w-full lg:mx-0">
        <div className={`${container} !px-0`}>{TimerRender()}</div>
      </div>

      <div className="flex justify-center mb-4">
        <img src={logoImg} alt="logo" className="max-w-[178px]" />
      </div>

      <div className="flex justify-center mb-4">
        <img src={readyImg} alt="ready" className="max-w-full w-[400px]" />
      </div>

      <div className="flex justify-center mb-4">
        <img src={welcomeImg} alt="welcome" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={`bg-[#a48256] max-w-[350px] !font-[800] !text-[18px] text-[#ffffff] mb-4`}
          text="GET MY COLORS"
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      <div className="flex justify-center mb-2">
        <img src={stopImg} alt="stop" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <img src={beforeImg} alt="before" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={`bg-[#a48256] max-w-[350px] !font-[800] !text-[18px] text-[#ffffff] mb-4`}
          text="GET MY COLORS"
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      <div className="flex justify-center mb-4">
        <img src={includedImg} alt="button" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4 -mx-4">
        <img src={freeGiftImg} alt="gift" className="max-w-full w-full" />
      </div>

      <div className="flex justify-center mb-4 -mx-4">
        <img src={analyzetImg} alt="analyzet" className="max-w-full w-full" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={`bg-[#a48256] max-w-[350px] !font-[800] !text-[18px] text-[#ffffff] mb-4`}
          text="GET MY COLORS"
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      <div className="flex justify-center mb-4">
        <img src={toolsImg} alt="tools" className="max-w-full w-[350px]" />
      </div>

      <div className="h-[2px] w-full mb-4 bg-[#232323]"></div>

      <div className="flex justify-center mb-4">
        <img src={seeImg} alt="see" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4 -mx-4">
        <img src={resultImg} alt="result" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4 ">
        <img src={mediaImg} alt="media" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4 ">
        <img src={bloggersImg} alt="blog" className="max-w-full w-[500px]" />
      </div>

      {showPromoCode && (
        <div className="my-4 rounded-[8px] bg-[#CAEFF9] px-5 py-4">
          {discountBlockRender()}
        </div>
      )}

      <div>
        <div
          ref={discountBlockRef}
          className={
            "rounded-[8px] border-[2px] border-[#DBE6E2] px-4 pb-[22px] pt-8"
          }
        >
          <p className={"mb-6 text-[16px] leading-5 text-[#0A364A] text-left"}>
            We've helped thousands of women discover their style and glow with
            confidence, and now we want to help you too 🔥
          </p>
          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#0A364A] text-left"
            }
          >
            We believe money shouldn't be a barrier to feeling fabulous and
            finally solving wardrobe challenges once and for all. So, choose the
            amount you think is reasonable to try us for 1 week ❤️❤️❤️
          </p>

          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#BD4192] text-left"
            }
          >
            It costs us $9.78 to cover our expenses for the trial, but we want
            you to pick a price that you're comfortable with.
          </p>

          <div
            className={
              "mb-1 mr-3 flex justify-end text-[14px] leading-5 text-[#6894A8]"
            }
          >
            most popular choice*
          </div>

          <div className={"mb-6 flex justify-between"}>
            {landingPlans.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    onPlanClick(item);
                  }}
                  className={`w-[48%] rounded-[8px] border border-[#DBE6E2] bg-[#F5F7F8] py-4 transition duration-300 ${
                    plan === item.value ? "!border-[#08A0C8] !bg-[#E0EEF1]" : ""
                  }`}
                  key={`${index}-plan`}
                >
                  <p
                    className={
                      "text-center text-[16px] font-[900] leading-[22px]"
                    }
                  >
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          {isApplePayAvailible === false ? (
            <div>
              <Button
                buttonStyles={
                  "bg-[#a48256] !font-[800] !text-[18px] text-[#ffffff] mb-4"
                }
                text="GET MY COLORS"
                isButtonDisabled={!plan}
                action={() => onPopupOpenClick()}
              />
              <p
                className={
                  "text-center text-[16px] leading-[22px] text-[#3E636C]"
                }
              >
                *7-day trial
              </p>

              <p className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2">
                By continue you agree that after the 7-day trial period ends,
                Color-analysis.pro will automatically continue your membership
                and charge 29.99$ every 3 months until you cancel it online in
                the{" "}
                personal account{" "}
                or by email. Learn more about cancellation and refund policy in{" "}
                <a
                  href="https://color-analysis.pro/refund"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  Subscription Terms
                </a>
                .
              </p>
            </div>
          ) : (
            <div
              className={`relative ${
                plan === null ? "h-0 max-h-0" : "h-[auto] !max-h-[750px]"
              } transiton overflow-hidden duration-300`}
            >
              <div className={`relative`}>
                <div>{renderFullForm(true)}</div>
              </div>

              <div>
                <p
                  onClick={() => setPopupOpen(true)}
                  className="cursor-pointer text-center text-[16px] font-[500] text-[#0A364A] underline"
                >
                  Continue with other payment options
                </p>
              </div>

              <p className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2">
                By continue you agree that after the 7-day trial period ends,
                Color-analysis.pro will automatically continue your membership
                and charge 29.99$ every 3 months until you cancel it online in
                the{" "}
                <a
                  href="https://color-analysis.pro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  personal account
                </a>{" "}
                or by email. Learn more about cancellation and refund policy in{" "}
                <a
                  href="https://color-analysis.pro/refund"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#1f497d] underline"
                >
                  {" "}
                  Subscription Terms
                </a>
                .
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-center mb-10 ">
        <img src={visaImg} alt="visa" className="max-w-full w-[500px]" />
      </div>

      {isPopupOpen ? (
        <Popup
          content={<div className="pt-4">{renderPopupForm()}</div>}
          isOpen={isPopupOpen}
          closeFunction={() => onClosePopupClick()}
        />
      ) : null}
    </div>
  );
}

export default Paywall;
